import type { AnyFunc } from '@/types';

/**
 * returns an executable function
 *  that will wrap in a try/catch statement
 * */
export default (functionToExec: AnyFunc) => () => {
  try {
    functionToExec.apply(this);
  } catch (e) {
    // catch errors and throw in console
    // will continue with other code
    console.error(e);
  }
};
